export interface GiftTemplate {
  label: string
  value: string
}

/**
 * 赠送内容模板。
 * 说明：模板内容为普通 JSON，前端只做语法校验，不校验业务字段结构。
 * 下方为占位示例，待客户端确认真实结构后直接替换本文件即可。
 */
export const GIFT_TEMPLATES: GiftTemplate[] = [
  {
    label: '单分区模板',
    value: JSON.stringify(
      [
        {
          zoneId: '10001',
          giftItems: [{ itemId: 'SWORD_001', itemNum: 1 }],
        },
      ],
      null,
      2,
    ),
  },
]
